
// Checkout routing: ADD TO CART goes straight to Shopify checkout with the selected
// subscription selling plan. CheckoutChamp's route() stays stubbed so no CC checkout occurs.
window.route = window.route || function(){ return false; };

// Shopify variant + selling plan mapping for the two offer tiers.
// Tier 1: 3 Month AutoShip & Save -> variant "Every 3 Months" + "Deliver every 3 months" plan ($78 first, $132 renewal)
// Tier 2: 1 Month AutoShip & Save -> variant "Every Month" + "Deliver every month" plan ($39 first, $44 renewal)
window.methodicShopifyOffers = {
  1: { variantId: 48770568454376, sellingPlanId: 7154958568, quantity: 1 },
  2: { variantId: 48770568421608, sellingPlanId: 7154893032, quantity: 1 }
};

      // Customer reviews: working star-rating filter + show more/less
      (function(){
        var section = document.querySelector('.crev');
        if(!section) return;
        var cards = Array.prototype.slice.call(section.querySelectorAll('.rc'));
        var showMoreBtn = section.querySelector('.show-more');
        var filterBtn = section.querySelector('.filter');
        var menu = section.querySelector('.filter-menu');
        var emptyMsg = section.querySelector('.rev-empty');
        var LIMIT = 4;
        var state = { filter: 'all', expanded: false };

        function matches(c){ return state.filter === 'all' || c.getAttribute('data-rating') === state.filter; }

        function render(){
          var shown = 0, total = 0;
          cards.forEach(function(c){
            if(matches(c)){
              total++;
              if(state.expanded || shown < LIMIT){ c.style.display=''; shown++; }
              else { c.style.display='none'; }
            } else {
              c.style.display='none';
            }
          });
          if(emptyMsg) emptyMsg.style.display = total === 0 ? 'block' : 'none';
          if(total > LIMIT){
            showMoreBtn.style.display='block';
            showMoreBtn.textContent = state.expanded ? 'Show fewer reviews' : 'Show more reviews';
          } else {
            showMoreBtn.style.display='none';
          }
        }

        showMoreBtn.addEventListener('click', function(){ state.expanded = !state.expanded; render(); });

        // filter dropdown
        filterBtn.addEventListener('click', function(e){ e.stopPropagation(); menu.classList.toggle('open'); });
        menu.addEventListener('click', function(e){ e.stopPropagation(); });
        document.addEventListener('click', function(){ menu.classList.remove('open'); });
        Array.prototype.slice.call(menu.querySelectorAll('[data-val]')).forEach(function(opt){
          opt.addEventListener('click', function(){
            state.filter = opt.getAttribute('data-val');
            state.expanded = false;
            menu.querySelectorAll('[data-val]').forEach(function(o){ o.classList.remove('active'); });
            opt.classList.add('active');
            menu.classList.remove('open');
            render();
          });
        });

        render();
      })();

      // Plan card selection + CheckoutChamp product synchronization.
      // Product IDs: 3 Month AutoShip & Save = 158 (default), 1 Month AutoShip & Save = 156.
      var methodicOfferData = {
        1: { id: 158, price: '$78', compare: '$132', save: 'GET 1ST MONTH FREE' },
        2: { id: 156, price: '$39', compare: '$44', save: '$5 OFF FIRST ORDER' }
      };
      var currentBundle = 1;
      function syncMethodicCheckoutProduct(productId) {
        var selectedId = parseInt(productId, 10);
        var allRadios = document.querySelectorAll('.mw-cc-radio-hidden, input[name="product"]');
        allRadios.forEach(function(radio) {
          var shouldCheck = (parseInt(radio.value, 10) === selectedId);
          radio.checked = shouldCheck;
          if (shouldCheck) radio.setAttribute('checked', '');
          else radio.removeAttribute('checked');
        });
      }
      function updateMethodicQuantityUI() {
        var cards = Array.prototype.slice.call(document.querySelectorAll('.qty-grid .qty[data-tier]'));
        var gifts = Array.prototype.slice.call(document.querySelectorAll('.gifts-grid .gift'));
        var unlockCount = { 1: gifts.length, 2: gifts.length };
        var selectedOffer = methodicOfferData[currentBundle] || methodicOfferData[1];
        cards.forEach(function(card) {
          var tier = parseInt(card.getAttribute('data-tier'), 10);
          card.classList.toggle('sel', tier === currentBundle);
        });
        var selectedCard = document.querySelector('.qty-grid .qty[data-tier="' + currentBundle + '"]');
        var selectedProductId = selectedCard ? selectedCard.getAttribute('data-product-id') : selectedOffer.id;
        gifts.forEach(function(gift, i) {
          gift.classList.toggle('unlocked', i < (unlockCount[currentBundle] || 0));
        });
        syncMethodicCheckoutProduct(selectedProductId || selectedOffer.id);
        var refillNote = document.getElementById('mw-refill-note');
        if (refillNote) {
          refillNote.textContent = (currentBundle === 1) ? 'Refills Ship Every 90 Days' : 'Refills Ship Every 30 Days';
        }
      }
      window.mwSelectBundle = function(n) {
        currentBundle = parseInt(n, 10) || 1;
        updateMethodicQuantityUI();
      };
      window.methodicSelectBundle = window.mwSelectBundle;
      function syncMethodicSelectedProductBeforeCheckout() {
        var selectedCard = document.querySelector('.qty-grid .qty.sel[data-product-id]');
        var fallbackOffer = methodicOfferData[currentBundle] || methodicOfferData[1];
        syncMethodicCheckoutProduct(selectedCard ? selectedCard.getAttribute('data-product-id') : fallbackOffer.id);
      }
      window.syncMethodicSelectedProductBeforeCheckout = syncMethodicSelectedProductBeforeCheckout;
      (function(){
        var cards = Array.prototype.slice.call(document.querySelectorAll('.qty-grid .qty[data-tier]'));
        cards.forEach(function(el){
          el.setAttribute('role', 'button');
          if (!el.hasAttribute('tabindex')) el.setAttribute('tabindex', '0');
          el.addEventListener('click', function(){ window.mwSelectBundle(el.getAttribute('data-tier')); });
          el.addEventListener('keydown', function(event){
            if (event.key === 'Enter' || event.key === ' ') {
              event.preventDefault();
              window.mwSelectBundle(el.getAttribute('data-tier'));
            }
          });
        });
        function methodicGoToShopifyCheckout(button) {
          var offer = window.methodicShopifyOffers[currentBundle] || window.methodicShopifyOffers[1];
          if (!offer) return;
          var originalText = button ? button.textContent : '';
          if (button) {
            if (button.getAttribute('data-mw-busy') === '1') return;
            button.setAttribute('data-mw-busy', '1');
            button.textContent = 'PROCESSING\u2026';
          }
          function restore() {
            if (button) {
              button.removeAttribute('data-mw-busy');
              button.textContent = originalText;
            }
          }
          fetch('/cart/clear.js', { method: 'POST' })
            .then(function() {
              return fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ items: [{ id: offer.variantId, quantity: offer.quantity, selling_plan: offer.sellingPlanId }] })
              });
            })
            .then(function(response) {
              if (!response.ok) throw new Error('cart add failed: ' + response.status);
              return response.json();
            })
            .then(function() {
              window.location.href = '/checkout';
            })
            .catch(function() {
              // Fallback: cart permalink goes straight to checkout as well.
              window.location.href = '/cart/' + offer.variantId + ':' + offer.quantity + '?selling_plan=' + offer.sellingPlanId;
              setTimeout(restore, 3000);
            });
        }
        window.methodicGoToShopifyCheckout = methodicGoToShopifyCheckout;
        document.querySelectorAll('button[action="route"], button[title="GOOOTOCHECKOUT"]').forEach(function(button) {
          button.addEventListener('click', function(event) {
            event.preventDefault();
            event.stopPropagation();
            syncMethodicSelectedProductBeforeCheckout();
            methodicGoToShopifyCheckout(button);
          }, true);
        });
        var selected = document.querySelector('.qty-grid .qty.sel[data-tier]');
        currentBundle = selected ? (parseInt(selected.getAttribute('data-tier'), 10) || 1) : 1;
        updateMethodicQuantityUI();
      })();

      // Timeline: fill the progress line in proportion to scroll, revealing each check as the
      // line reaches its dot, and unfilling when the user scrolls back up.
      (function(){
        var tl = document.querySelector('.tl');
        if(!tl) return;
        var items = Array.prototype.slice.call(tl.querySelectorAll('.tl-item'));
        if(!items.length) return;

        // real fill element layered over the static ::before track
        var fillEl = document.createElement('span');
        fillEl.className = 'tl-fill';
        tl.appendChild(fillEl);

        function positionFill(){
          var d = window.matchMedia('(min-width:900px)').matches;
          fillEl.style.left = d ? '50%' : '18px';
          fillEl.style.transform = d ? 'translateX(-50%)' : 'none';
        }

        var ticking = false;
        function onScroll(){
          if(ticking) return;
          ticking = true;
          requestAnimationFrame(render);
        }

        function render(){
          ticking = false;
          var tlRect = tl.getBoundingClientRect();
          var trackTop = 8;                              // matches CSS top:8px
          var trackBottom = tlRect.height - 8;
          var trackLen = Math.max(1, trackBottom - trackTop);

          // the "reveal line" sits ~58% down the viewport
          var revealY = window.innerHeight * 0.58;
          // distance, in timeline-local coords, from track top to the reveal line
          var progressPx = (revealY - tlRect.top) - trackTop;
          progressPx = Math.max(0, Math.min(trackLen, progressPx));

          fillEl.style.height = progressPx + 'px';

          // toggle each dot based on whether the fill has reached its centre
          items.forEach(function(it){
            var dot = it.querySelector('.tl-dot');
            if(!dot) return;
            var dotRect = dot.getBoundingClientRect();
            var dotCentreLocal = (dotRect.top + dotRect.height/2) - tlRect.top - trackTop;
            if(progressPx >= dotCentreLocal){
              it.classList.add('active');
            } else {
              it.classList.remove('active');
            }
          });
        }

        positionFill();
        window.addEventListener('scroll', onScroll, {passive:true});
        window.addEventListener('resize', function(){ positionFill(); render(); });
        // initial paint
        render();
      })();

      // Sticky redeem bar visibility and offer-scroll behavior
      (function(){
        var bar = document.querySelector('.sticky-redeem');
        var offer = document.getElementById('cc-id-quBttIkYmxdy');
        var productHeroImage = document.querySelector('.offer-media .offer-hero [data-gallery-role="main"], .offer-media .offer-hero .product-photo, #cc-id-e04kGqHHlj4k');
        if(!bar || !offer) return;

        function offerTop(){
          return offer.getBoundingClientRect().top + (window.pageYOffset || document.documentElement.scrollTop || 0);
        }

        function setVisible(show){
          bar.classList.toggle('is-visible', !!show);
          bar.setAttribute('aria-hidden', show ? 'false' : 'true');
        }

        function syncStickyRedeem(){
          var y = window.pageYOffset || document.documentElement.scrollTop || 0;
          var bottom = y + window.innerHeight;
          var top = offerTop();
          var show = y > 140 && bottom < (top - 10);
          setVisible(show);
        }

        function redeemScroll(e){
          return window.ccScrollToProductHero ? window.ccScrollToProductHero(e) : false;
        }

        var redeem = bar.querySelector('.btn');
        if(redeem){
          redeem.addEventListener('click', redeemScroll);
          redeem.addEventListener('keydown', function(e){
            if(e.key === 'Enter' || e.key === ' '){ redeemScroll(e); }
          });
        }
        bar.addEventListener('click', function(e){
          if(e.target === bar || e.target.closest('.l')) redeemScroll(e);
        });

        var ticking = false;
        window.addEventListener('scroll', function(){
          if(!ticking){
            window.requestAnimationFrame(function(){
              syncStickyRedeem();
              ticking = false;
            });
            ticking = true;
          }
        }, { passive: true });
        window.addEventListener('resize', syncStickyRedeem);
        syncStickyRedeem();
      })();
    


      (function(){
        function inferType(url){
          var clean=(url||'').split('?')[0].toLowerCase();
          if(clean.endsWith('.webm')) return 'video/webm';
          if(clean.endsWith('.mov')) return 'video/quicktime';
          return 'video/mp4';
        }
        document.querySelectorAll('.video-paste-slot').forEach(function(slot){
          var url=(slot.getAttribute('data-video-src')||'').trim();
          if(url && !slot.querySelector('video, iframe')){
            var video=document.createElement('video');
            video.controls=true;
            video.playsInline=true;
            video.preload='metadata';
            var source=document.createElement('source');
            source.src=url;
            source.type=inferType(url);
            video.appendChild(source);
            slot.appendChild(video);
            slot.classList.add('has-video');
          }
          if(slot.querySelector('video, iframe')) slot.classList.add('has-video');
        });
      })();
    


      (function(){
        'use strict';
        var galleryState = { current: 0, initialized: false };

        function closest(el, selector){
          while(el && el.nodeType === 1){
            if(el.matches && el.matches(selector)) return el;
            el = el.parentElement;
          }
          return null;
        }

        function getGallery(){
          var media = document.querySelector('.offer-media');
          if(!media) return null;
          var hero = media.querySelector('.offer-hero');
          var main = media.querySelector('[data-gallery-role="main"], .offer-hero .product-photo');
          var thumbs = Array.prototype.slice.call(media.querySelectorAll('.thumbs .t')).slice(0, 7);
          if(!hero || !main || thumbs.length < 2) return null;
          var items = thumbs.map(function(t, i){
            var img = t.querySelector('img');
            var src = (img && (img.getAttribute('src') || img.getAttribute('data-src'))) || t.getAttribute('data-gallery-src') || '';
            var alt = (img && img.getAttribute('alt')) || ('Methodic Bio product gallery image ' + (i + 1));
            t.setAttribute('data-gallery-index', String(i));
            t.setAttribute('role', 'button');
            t.setAttribute('tabindex', '0');
            t.setAttribute('aria-label', 'View product gallery image ' + (i + 1));
            if(src){ t.setAttribute('data-gallery-src', src); }
            if(img){ img.setAttribute('draggable', 'false'); }
            return { src: src, alt: alt.replace(/thumbnail/i, 'image') };
          }).filter(function(item){ return !!item.src; });
          if(items.length < 2) return null;
          return { media: media, hero: hero, main: main, thumbs: thumbs, items: items };
        }

        function normalize(index, total){
          return ((index % total) + total) % total;
        }

        function setActive(index){
          var g = getGallery();
          if(!g) return false;
          galleryState.current = normalize(parseInt(index, 10) || 0, g.items.length);
          var selected = g.items[galleryState.current];
          g.main.style.opacity = '0.35';
          window.setTimeout(function(){
            g.main.setAttribute('src', selected.src);
            g.main.setAttribute('data-src', selected.src);
            g.main.setAttribute('alt', selected.alt);
            g.main.setAttribute('data-gallery-role', 'main');
            g.main.setAttribute('data-gallery-index', String(galleryState.current));
            g.main.style.opacity = '1';
          }, 45);
          g.thumbs.forEach(function(t, i){
            var active = i === galleryState.current;
            t.classList.toggle('active', active);
            t.setAttribute('aria-current', active ? 'true' : 'false');
          });
          return false;
        }

        function step(delta){
          var g = getGallery();
          if(!g) return false;
          var currentFromMain = parseInt(g.main.getAttribute('data-gallery-index'), 10);
          if(!isNaN(currentFromMain)) galleryState.current = currentFromMain;
          return setActive(galleryState.current + (parseInt(delta, 10) || 0));
        }

        window.ccProductGalleryGo = setActive;
        window.ccProductGalleryStep = step;
        window.ccProductGalleryKey = function(e, index){
          e = e || window.event;
          var key = e.key || e.keyCode;
          if(key === 'Enter' || key === ' ' || key === 13 || key === 32){ if(e.preventDefault) e.preventDefault(); return setActive(index); }
          if(key === 'ArrowRight' || key === 39){ if(e.preventDefault) e.preventDefault(); return step(1); }
          if(key === 'ArrowLeft' || key === 37){ if(e.preventDefault) e.preventDefault(); return step(-1); }
          return true;
        };
        window.ccProductGalleryArrowKey = function(e, dir){
          e = e || window.event;
          var key = e.key || e.keyCode;
          if(key === 'Enter' || key === ' ' || key === 13 || key === 32){ if(e.preventDefault) e.preventDefault(); return step(dir); }
          return true;
        };

        function bindGallery(){
          var g = getGallery();
          if(!g) return;
          if(g.media.getAttribute('data-cc-gallery-bound') === 'true'){
            setActive(parseInt(g.main.getAttribute('data-gallery-index'), 10) || 0);
            return;
          }
          g.media.setAttribute('data-cc-gallery-bound', 'true');

          // Capture-phase event delegation survives DOM replacements and nested image clicks.
          document.addEventListener('click', function(e){
            var thumb = closest(e.target, '.offer-media .thumbs .t');
            if(thumb){ if(e.preventDefault) e.preventDefault(); return setActive(parseInt(thumb.getAttribute('data-gallery-index'), 10) || 0); }
            var arrow = closest(e.target, '.offer-media .gallery-arrow, .offer-media .thumbs .arrow');
            if(arrow){ if(e.preventDefault) e.preventDefault(); return step(parseInt(arrow.getAttribute('data-gallery-dir'), 10) || 1); }
          }, true);

          var startX = 0, startY = 0, startTime = 0;
          function start(x, y){ startX = x; startY = y; startTime = Date.now(); }
          function end(x, y){
            var dx = x - startX;
            var dy = y - startY;
            var elapsed = Date.now() - startTime;
            if(Math.abs(dx) > 35 && Math.abs(dx) > Math.abs(dy) * 1.25 && elapsed < 1000){
              return step(dx < 0 ? 1 : -1);
            }
            return true;
          }

          [g.hero, g.main, g.media].forEach(function(el){
            if(!el) return;
            el.addEventListener('touchstart', function(e){ if(e.touches && e.touches.length === 1) start(e.touches[0].clientX, e.touches[0].clientY); }, { passive: true });
            el.addEventListener('touchend', function(e){ if(e.changedTouches && e.changedTouches.length === 1) end(e.changedTouches[0].clientX, e.changedTouches[0].clientY); }, { passive: true });
            el.addEventListener('pointerdown', function(e){ if(e.pointerType === 'touch' || e.pointerType === 'pen') start(e.clientX, e.clientY); }, { passive: true });
            el.addEventListener('pointerup', function(e){ if(e.pointerType === 'touch' || e.pointerType === 'pen') end(e.clientX, e.clientY); }, { passive: true });
            el.addEventListener('dragstart', function(e){ if(e.preventDefault) e.preventDefault(); });
          });

          setActive(parseInt(g.main.getAttribute('data-gallery-index'), 10) || 0);
          galleryState.initialized = true;
        }

        bindGallery();
        if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bindGallery);
        window.addEventListener('load', bindGallery);
        window.setTimeout(bindGallery, 250);
        window.setTimeout(bindGallery, 1000);
        if(window.MutationObserver){
          new MutationObserver(function(){ if(!document.querySelector('.offer-media[data-cc-gallery-bound="true"]')) bindGallery(); }).observe(document.documentElement, { childList: true, subtree: true });
        }
      })();
    


      (function(){
        'use strict';

        function getScrollTop(){
          return window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
        }

        function getProductHeroTarget(){
          return document.querySelector('.offer-media .offer-hero [data-gallery-role="main"], .offer-media .offer-hero .product-photo, #cc-id-e04kGqHHlj4k');
        }

        function getStickyOffset(){
          var offset = 0;
          var candidates = document.querySelectorAll('.sticky-header, .site-header, header[style*="fixed"], header[style*="sticky"], [class*="sticky"][class*="header"], [class*="fixed"][class*="header"]');
          candidates.forEach(function(el){
            var cs = window.getComputedStyle(el);
            if((cs.position === 'fixed' || cs.position === 'sticky') && el.getBoundingClientRect().top <= 4){
              offset = Math.max(offset, el.getBoundingClientRect().height || 0);
            }
          });
          return Math.min(Math.max(offset, 0), 140);
        }

        function exactProductHeroY(){
          var target = getProductHeroTarget();
          if(!target) return null;
          var rect = target.getBoundingClientRect();
          var offset = getStickyOffset();
          var margin = window.matchMedia && window.matchMedia('(max-width: 767px)').matches ? 8 : 12;
          return Math.max(0, Math.round(rect.top + getScrollTop() - offset - margin));
        }

        function jumpToExactProductHero(behavior){
          var y = exactProductHeroY();
          if(y === null) return false;
          window.scrollTo({ top: y, left: 0, behavior: behavior || 'auto' });
          return true;
        }

        window.ccScrollToProductHero = function(e){
          if(e){
            if(e.preventDefault) e.preventDefault();
            if(e.stopPropagation) e.stopPropagation();
            if(e.stopImmediatePropagation) e.stopImmediatePropagation();
          }

          var target = getProductHeroTarget();
          if(!target) return false;

          if(target.loading === 'lazy'){
            target.loading = 'eager';
          }

          jumpToExactProductHero('smooth');

          // Re-settle after lazy image decoding, sticky bar visibility changes, and smooth-scroll rounding.
          [120, 320, 700, 1100].forEach(function(delay){
            window.setTimeout(function(){ jumpToExactProductHero('auto'); }, delay);
          });

          if(target.decode){
            target.decode().then(function(){ jumpToExactProductHero('auto'); }).catch(function(){});
          }

          return false;
        };

        document.addEventListener('click', function(e){
          var btn = e.target && e.target.closest ? e.target.closest('button[onclick*="ccScrollToProductHero"], .sticky-redeem, .sticky-redeem .btn') : null;
          if(btn){
            window.ccScrollToProductHero(e);
          }
        }, true);
      })();
    


      (function(){
        'use strict';

        // Dynamic currency display DISABLED per store owner request (2026-07-18):
        // all prices must always display in USD ($) to match Shopify checkout.
        return;

        if (window.methodicDynamicCurrencyDisplay && window.methodicDynamicCurrencyDisplay.version) return;

        var SUPPORTED_CURRENCIES = ['USD', 'NZD', 'CAD', 'AUD', 'EUR', 'GBP'];
        var BASE_CURRENCY = 'USD';
        var FALLBACK_RATES = {
          USD: 1,
          NZD: 1.62,
          CAD: 1.36,
          AUD: 1.50,
          EUR: 0.92,
          GBP: 0.79
        };
        var CURRENCY_SYMBOLS = {
          USD: '$',
          NZD: 'NZ$',
          CAD: 'C$',
          AUD: 'A$',
          EUR: '€',
          GBP: '£'
        };
        var CURRENCY_LOCALES = {
          USD: 'en-US',
          NZD: 'en-NZ',
          CAD: 'en-CA',
          AUD: 'en-AU',
          EUR: 'de-DE',
          GBP: 'en-GB'
        };
        var EURO_COUNTRIES = {
          AD: true, AT: true, BE: true, CY: true, DE: true, EE: true,
          ES: true, FI: true, FR: true, GR: true, HR: true, IE: true,
          IT: true, LT: true, LU: true, LV: true, MC: true, ME: true,
          MT: true, NL: true, PT: true, SI: true, SK: true, SM: true,
          VA: true, XK: true
        };
        var COUNTRY_TO_CURRENCY = {
          NZ: 'NZD',
          CA: 'CAD',
          AU: 'AUD',
          GB: 'GBP',
          UK: 'GBP'
        };
        Object.keys(EURO_COUNTRIES).forEach(function(countryCode){
          COUNTRY_TO_CURRENCY[countryCode] = 'EUR';
        });

        var currentCurrency = BASE_CURRENCY;
        var currentRate = 1;
        var originalTextByNode = typeof WeakMap !== 'undefined' ? new WeakMap() : null;
        var observed = false;
        var mutationTimer = null;
        var applying = false;

        function normalizeCurrency(code){
          code = String(code || '').trim().toUpperCase();
          if (code === 'UK') code = 'GBP';
          return SUPPORTED_CURRENCIES.indexOf(code) >= 0 ? code : BASE_CURRENCY;
        }

        function getRegionFromLocale(locale){
          var parts = String(locale || '').split(/[-_]/);
          if (parts.length >= 2) return parts[parts.length - 1].toUpperCase();
          return '';
        }

        function currencyFromCountry(countryCode){
          countryCode = String(countryCode || '').trim().toUpperCase();
          return COUNTRY_TO_CURRENCY[countryCode] || BASE_CURRENCY;
        }

        function currencyFromTimeZone(){
          try {
            var tz = Intl.DateTimeFormat().resolvedOptions().timeZone || '';
            if (/^Pacific\/Auckland|^Pacific\/Chatham/.test(tz)) return 'NZD';
            if (/^Australia\//.test(tz)) return 'AUD';
            if (/^Europe\/London|^Europe\/Jersey|^Europe\/Guernsey|^Europe\/Isle_of_Man/.test(tz)) return 'GBP';
            if (/^America\/(Toronto|Vancouver|Winnipeg|Edmonton|Halifax|St_Johns|Moncton|Regina|Whitehorse|Yellowknife|Iqaluit|Rankin_Inlet|Resolute|Dawson|Dawson_Creek|Glace_Bay|Goose_Bay|Inuvik|Swift_Current|Thunder_Bay)/.test(tz)) return 'CAD';
            if (/^Europe\/(Amsterdam|Andorra|Athens|Belgrade|Berlin|Bratislava|Brussels|Busingen|Chisinau|Dublin|Gibraltar|Helsinki|Kiev|Kyiv|Lisbon|Ljubljana|Luxembourg|Madrid|Malta|Mariehamn|Monaco|Nicosia|Paris|Podgorica|Prague|Riga|Rome|San_Marino|Sarajevo|Skopje|Tallinn|Tirane|Vaduz|Vatican|Vienna|Vilnius|Zagreb)/.test(tz)) return 'EUR';
          } catch(e) {}
          return BASE_CURRENCY;
        }

        function detectCurrencyFromBrowser(){
          var override = '';
          try {
            var params = new URLSearchParams(window.location.search || '');
            override = params.get('currency') || params.get('cc_currency') || params.get('display_currency') || '';
          } catch(e) {}
          override = normalizeCurrency(override);
          if (override !== BASE_CURRENCY) return override;

          var languages = [];
          if (navigator.languages && navigator.languages.length) languages = Array.prototype.slice.call(navigator.languages);
          if (navigator.language) languages.push(navigator.language);
          for (var i = 0; i < languages.length; i++) {
            var region = getRegionFromLocale(languages[i]);
            var currency = currencyFromCountry(region);
            if (currency !== BASE_CURRENCY) return currency;
          }

          return currencyFromTimeZone();
        }

        function formatNumber(amount, decimals){
          var factor = Math.pow(10, decimals);
          amount = Math.round((amount + Number.EPSILON) * factor) / factor;
          var fixed = amount.toFixed(decimals);
          var pieces = fixed.split('.');
          pieces[0] = pieces[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
          return pieces.join('.');
        }

        function formatCurrency(amount, currency, originalNumber){
          var hadDecimals = /\.\d/.test(originalNumber || '');
          var originalAmount = parseFloat(String(originalNumber || '').replace(/,/g, '')) || 0;
          var decimals = hadDecimals || originalAmount < 10 ? 2 : 0;
          return (CURRENCY_SYMBOLS[currency] || '$') + formatNumber(amount, decimals);
        }

        function convertUsdText(text, currency, rate){
          if (!text || text.indexOf('$') === -1) return text;
          if (currency === BASE_CURRENCY) return text;
          return text.replace(/\$(\s*)(\d[\d,]*(?:\.\d{1,2})?)/g, function(match, spacing, numberText){
            var usdAmount = parseFloat(String(numberText).replace(/,/g, ''));
            if (!isFinite(usdAmount)) return match;
            return formatCurrency(usdAmount * rate, currency, numberText);
          });
        }

        function shouldSkipElement(el){
          if (!el || el.nodeType !== 1) return false;
          var tag = (el.tagName || '').toLowerCase();
          if (/^(script|style|noscript|textarea|select|option|template|svg|path)$/.test(tag)) return true;
          if (el.closest && el.closest('script, style, noscript, textarea, select, option, template, [data-no-currency-convert]')) return true;
          return false;
        }

        function rememberOriginalText(node){
          if (!originalTextByNode) {
            if (typeof node.__methodicOriginalUsdText === 'undefined') node.__methodicOriginalUsdText = node.nodeValue;
            return node.__methodicOriginalUsdText;
          }
          if (!originalTextByNode.has(node)) originalTextByNode.set(node, node.nodeValue);
          return originalTextByNode.get(node);
        }

        function applyTextNode(node, currency, rate){
          if (!node || node.nodeType !== 3 || !node.nodeValue || node.nodeValue.indexOf('$') === -1) return;
          if (shouldSkipElement(node.parentElement)) return;
          var original = rememberOriginalText(node);
          node.nodeValue = convertUsdText(original, currency, rate);
        }

        function applyAttributes(el, currency, rate){
          if (!el || el.nodeType !== 1 || shouldSkipElement(el)) return;
          ['alt', 'title', 'aria-label'].forEach(function(attr){
            if (!el.hasAttribute || !el.hasAttribute(attr)) return;
            var value = el.getAttribute(attr);
            if (!value || value.indexOf('$') === -1) return;
            var originalAttr = 'data-methodic-original-' + attr;
            if (!el.hasAttribute(originalAttr)) el.setAttribute(originalAttr, value);
            el.setAttribute(attr, convertUsdText(el.getAttribute(originalAttr), currency, rate));
          });
        }

        function scanAndApply(root, currency, rate){
          root = root || document.body;
          if (!root) return;
          applying = true;
          try {
            if (root.nodeType === 3) {
              applyTextNode(root, currency, rate);
              return;
            }
            if (root.nodeType !== 1 && root.nodeType !== 9 && root.nodeType !== 11) return;
            if (root.nodeType === 1) applyAttributes(root, currency, rate);
            var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
              acceptNode: function(node){
                if (!node.nodeValue || node.nodeValue.indexOf('$') === -1) return NodeFilter.FILTER_REJECT;
                if (shouldSkipElement(node.parentElement)) return NodeFilter.FILTER_REJECT;
                return NodeFilter.FILTER_ACCEPT;
              }
            });
            var textNode;
            while ((textNode = walker.nextNode())) applyTextNode(textNode, currency, rate);
            if (root.querySelectorAll) {
              Array.prototype.slice.call(root.querySelectorAll('[alt*="$"], [title*="$"], [aria-label*="$"]')).forEach(function(el){
                applyAttributes(el, currency, rate);
              });
            }
          } finally {
            applying = false;
          }
        }

        function applyCurrency(currency, rate){
          currentCurrency = normalizeCurrency(currency);
          currentRate = typeof rate === 'number' && isFinite(rate) && rate > 0 ? rate : (FALLBACK_RATES[currentCurrency] || 1);
          document.documentElement.setAttribute('data-methodic-display-currency', currentCurrency);
          document.documentElement.setAttribute('data-methodic-display-currency-locale', CURRENCY_LOCALES[currentCurrency] || 'en-US');
          scanAndApply(document.body, currentCurrency, currentRate);
        }

        function fetchRatesFor(currency){
          currency = normalizeCurrency(currency);
          if (currency === BASE_CURRENCY || !window.fetch) return Promise.resolve(FALLBACK_RATES[currency] || 1);
          var url = 'https://api.frankfurter.app/latest?from=USD&to=' + encodeURIComponent(currency);
          return fetch(url, { cache: 'reload' })
            .then(function(response){ return response.ok ? response.json() : null; })
            .then(function(data){
              var liveRate = data && data.rates && parseFloat(data.rates[currency]);
              return isFinite(liveRate) && liveRate > 0 ? liveRate : (FALLBACK_RATES[currency] || 1);
            })
            .catch(function(){ return FALLBACK_RATES[currency] || 1; });
        }

        function fetchCurrencyFromIp(){
          if (!window.fetch) return Promise.resolve(BASE_CURRENCY);
          var endpoints = [
            'https://ipapi.co/json/',
            'https://ipwho.is/'
          ];
          function requestEndpoint(index){
            if (index >= endpoints.length) return Promise.resolve(BASE_CURRENCY);
            return fetch(endpoints[index], { cache: 'reload' })
              .then(function(response){ return response.ok ? response.json() : null; })
              .then(function(data){
                var country = '';
                if (data) country = data.country_code || (data.country && data.country_code) || data.countryCode || '';
                var currency = currencyFromCountry(country);
                return currency !== BASE_CURRENCY ? currency : requestEndpoint(index + 1);
              })
              .catch(function(){ return requestEndpoint(index + 1); });
          }
          return requestEndpoint(0);
        }

        function scheduleMutationScan(){
          if (mutationTimer) window.clearTimeout(mutationTimer);
          mutationTimer = window.setTimeout(function(){
            mutationTimer = null;
            scanAndApply(document.body, currentCurrency, currentRate);
          }, 40);
        }

        function startObserver(){
          if (observed || !window.MutationObserver || !document.body) return;
          observed = true;
          var observer = new MutationObserver(function(mutations){
            if (applying) return;
            var shouldScan = false;
            mutations.forEach(function(mutation){
              if (mutation.type === 'childList' && mutation.addedNodes && mutation.addedNodes.length) shouldScan = true;
              if (mutation.type === 'characterData' && mutation.target && mutation.target.nodeValue && mutation.target.nodeValue.indexOf('$') >= 0) shouldScan = true;
            });
            if (shouldScan) scheduleMutationScan();
          });
          observer.observe(document.body, { childList: true, subtree: true, characterData: true });
        }

        function initialize(){
          var browserCurrency = detectCurrencyFromBrowser();
          applyCurrency(browserCurrency, FALLBACK_RATES[browserCurrency] || 1);
          startObserver();

          fetchCurrencyFromIp().then(function(ipCurrency){
            var detected = normalizeCurrency(ipCurrency);
            if (detected === BASE_CURRENCY) detected = browserCurrency;
            return fetchRatesFor(detected).then(function(rate){
              applyCurrency(detected, rate);
            });
          }).catch(function(){
            fetchRatesFor(browserCurrency).then(function(rate){
              applyCurrency(browserCurrency, rate);
            });
          });
        }

        window.methodicDynamicCurrencyDisplay = {
          version: '1.0.0',
          supportedCurrencies: SUPPORTED_CURRENCIES.slice(),
          baseCurrency: BASE_CURRENCY,
          fallbackRates: FALLBACK_RATES,
          detectCurrency: detectCurrencyFromBrowser,
          applyCurrency: function(currency, rate){
            var target = normalizeCurrency(currency);
            applyCurrency(target, rate || FALLBACK_RATES[target] || 1);
          },
          refresh: function(){ scanAndApply(document.body, currentCurrency, currentRate); },
          getCurrentCurrency: function(){ return currentCurrency; },
          getCurrentRate: function(){ return currentRate; }
        };

        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', initialize);
        } else {
          initialize();
        }
      })();
    